














































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
// import { copyToClipboard } from 'quasar'
import DeadlineTimer from 'components/DeadlineTimer.vue'
import api from 'src/assets/api/gql'
// import SessionProjectorAuthCodeCreate from 'src/graphql/session/SessionProjectorAuthCodeCreate.gql'
import { Session } from 'src/graphql/types'

@Component({
  components: {
    DeadlineTimer
  }
})
export default class SessionSlideshowSetup extends Vue {
  // copyToClipboard = copyToClipboard
  expand = false
  code = ''
  loading = false
  beginning = new Date()
  deadline = new Date()

  @Prop()
  readonly session!: Session

  @Watch('expand')
  async getCode (expand: boolean) {
    if (expand) {
      // this.loading = true
      // const { data: { createSessionProjectorAuthCode } } = await api.mutate({
      //   query: SessionProjectorAuthCodeCreate,
      //   variables: {
      //     sessionId: this.session.id
      //   }
      // })
      // this.loading = false
      // if (createSessionProjectorAuthCode && createSessionProjectorAuthCode.authCode) {
      //   this.code = createSessionProjectorAuthCode.authCode.code
      //   this.beginning = new Date()
      //   this.deadline = new Date(createSessionProjectorAuthCode.authCode.validTime)
      // }
    }
  }

  refresh () {
    this.getCode(this.expand)
  }
}
